<template>
	<div class="public-mask">
		<div class="public-content">
			<div class="public-title">
				<span>SFHOWE123JO</span>
				<i class="el-icon-close" @click="closeMask"></i>
			</div>
			<div class="public-box">
				<div class="public-item">
					<div class="public-item-title">
						委托人信息
					</div>
					<div class="public-item-area">
						<div class="public-unit">
							<div class="key">
								委托机构：
							</div>
							<div class="value">
								{{entrust.organization}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系人：
							</div>
							<div class="value">
								{{entrust.concat}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系方式：
							</div>
							<div class="value">
								{{entrust.phone}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								委托人：
							</div>
							<div class="value">
								{{entrust.name}}
							</div>
						</div>
						<div class="public-unit-mid">
							<div class="key">
								地址：
							</div>
							<div class="value">
								{{entrust.address}}
							</div>
						</div>
						<div class="public-unit" v-if="userType==1">
							<div class="key">
								被鉴定人：
							</div>
							<div class="value">
								{{entrust.obj}}
							</div>
						</div>
						<div class="public-unit-mid" v-if="userType==1">
							<div class="key">
								证件号码：
							</div>
							<div class="value">
								{{entrust.code}}
							</div>
						</div>
						<div class="public-record" v-if="userType==1">
							<span v-if="record.length==0">该鉴定人暂无鉴定记录</span>
							<div class="public-record-item" v-for="(item,index) in record" :key="index">
								{{item.name}}（身份证：{{item.identity}}）于{{item.time}}在{{item.organization}}做过司法鉴定
							</div>
						</div>
					</div>
				</div>
				<div class="public-item">
					<div class="public-item-title">
						司法鉴定机构信息
					</div>
					<div class="public-item-area">
						<div class="public-unit">
							<div class="key">
								名称：
							</div>
							<div class="value">
								{{organization.name}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								许可证号：
							</div>
							<div class="value">
								{{organization.code}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								邮政编码：
							</div>
							<div class="value">
								{{organization.mail}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								地址：
							</div>
							<div class="value">
								{{organization.address}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系人：
							</div>
							<div class="value">
								{{organization.concat}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系电话：
							</div>
							<div class="value">
								{{organization.phone}}
							</div>
						</div>
					</div>
				</div>
				<div class="public-item">
					<div class="public-item-title">
						鉴定案件信息
					</div>
					<div class="public-item-area">
						<div class="public-unit-large">
							<div class="key">
								委托鉴定事项：
							</div>
							<div class="value">
								{{info.matter}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								补充事项：
							</div>
							<div class="value">
								{{info.supplement}}
							</div>
						</div>
						<div class="public-unit-large">
							<div class="key">
								是否重新鉴定：
							</div>
							<div class="value">
								{{info.repeat?'是':'否'}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'checked',
		data() {
			return {
				entrust:{
					organization:'公安局',
					concat:'吉姆哈克',
					phone:'0311-82019999',
					name:'河北省石家庄市公安局XX分局',
					address:'甘肃省临夏回族自治州广河县阳光胡同488号',
					obj:'紫苑',
					code:'915001197612032727'
				},
				record:[
					{
						name:'江户川柯南',
						identity:'130185197512120123',
						time:'2021年08月30日',
						organization:'河北中经天平司法鉴定中心'
					},
					{
						name:'江户川柯南',
						identity:'130185197512120123',
						time:'2021年08月30日',
						organization:'河北中经天平司法鉴定中心'
					},
					{
						name:'江户川柯南',
						identity:'130185197512120123',
						time:'2021年08月30日',
						organization:'河北中经天平司法鉴定中心'
					},
					{
						name:'江户川柯南',
						identity:'130185197512120123',
						time:'2021年08月30日',
						organization:'河北中经天平司法鉴定中心'
					}
				],
				organization:{
					name:'河北医科大学第一医院司法鉴定中心',
					code:'130001203',
					mail:'050200',
					address:'河北省石家庄市东岗路89号',
					concat:'紫苑',
					phone:'0311-82019999'
				},
				info:{
					matter:'人体损失程度鉴定',
					supplement:'天知团更易代论改北史没选切术科年还关了人际却新四养习都处也定产命见精离立过信定报五国压始带。',
					repeat:true
				}
			};
		},
		methods: {
			closeMask(){
				this.$emit('closeChecked')
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	@import url("../global.less");
</style>
